import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { FaComments } from 'react-icons/fa';
import './FeedbackButton.css';

const FeedbackButton = () => {
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { port, addAlert } = useContext(AppContext);
    const [feedback, setFeedback] = useState({
        email: '',
        message: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsSubmitting(true);

        try {
            await axios.post(`${port}/auth/feedback`, feedback);
            addAlert('Thank you for your feedback!', 'success');
            setShowModal(false);
            setFeedback({ email: '', message: '' });
        } catch (error) {
            addAlert('Error submitting feedback', 'danger');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <button 
                className="feedback-button"
                onClick={() => setShowModal(true)}
                aria-label="Submit Feedback"
            >
                <FaComments size={30} />
            </button>

            <Modal 
                show={showModal} 
                onHide={() => setShowModal(false)}
                className="feedback-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Submit Feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email Address</label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                value={feedback.email}
                                onChange={(e) => setFeedback({...feedback, email: e.target.value})}
                                required
                                placeholder="So we can get back to you"
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="message" className="form-label">Your Feedback</label>
                            <textarea
                                className="form-control"
                                id="message"
                                rows="4"
                                value={feedback.message}
                                onChange={(e) => setFeedback({...feedback, message: e.target.value})}
                                required
                                placeholder="Tell us what's on your mind..."
                            />
                        </div>
                        <button 
                            type="submit" 
                            className="btn btn-primary w-100"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default FeedbackButton;
